import { Popover, PopoverContent, PopoverTrigger } from "../ui/popover";
import { useTranslation } from "react-i18next";

export function ContactsPopover() {
  const { t } = useTranslation();

  return (
    <Popover>
      <PopoverTrigger asChild>
        <div className="cursor-pointer text-[#00000080] font-medium leading-[17px] text-[17px] hover:text-[#001D98]">
          {t("footer.contacts")}
        </div>
      </PopoverTrigger>
      <PopoverContent className="w-full p-4 flex flex-col items-start rounded-xl bg-white">
        <div className="flex flex-col text-left space-y-2">
          <span className="text-center">SIA Ecengo</span>
          <span>Reģistrācijas nr. 40203405805</span>
          <span>Juridiskā adrese: Avotu iela 23, Rīga, LV-1011</span>
          <span>Telefona nr: +37128006655</span>
          <span>
            E-pasts:{" "}
            <a
              href="mailto:ecengo@ecengo.lv"
              className="text-blue-500 underline"
            >
              ecengo@ecengo.lv
            </a>
          </span>
        </div>
      </PopoverContent>
    </Popover>
  );
}
